export const isPortrait = () => window.innerHeight > window.innerWidth;
